export default {
    "NUPR1":true,
    "CD74":true, 
    "THBS1":true, 
    "RHOH":true, 
    "CD69": true, 
    "ADGRE4P": true,
}